var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "availability-coverage-report",
      staticStyle: { width: "95%" },
      attrs: { fluid: "", "grid-list-md": "" },
    },
    [
      _c("h1", [_vm._v("Availability Coverage Report")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v(
            "\n            % represents the percentage of days that are unavailable.\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "v-btn",
            {
              attrs: { disabled: !_vm.multiplePages },
              on: {
                click: function ($event) {
                  return _vm.handlePageChange(-1)
                },
              },
            },
            [_vm._v("\n            < Previous\n        ")]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { disabled: !_vm.multiplePages },
              on: {
                click: function ($event) {
                  return _vm.handlePageChange(1)
                },
              },
            },
            [_vm._v(" \n            Next > \n        ")]
          ),
          _vm._v(" "),
          _vm.pageLoading
            ? _c("v-icon", { staticClass: "spin" }, [_vm._v("sync")])
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { width: "300px" } },
        [
          _c("v-text-field", {
            attrs: {
              "append-icon": "search",
              label: "Search",
              "single-line": "",
              "hide-details": "",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.loadData()
              },
            },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "table",
        [
          _c(
            "tr",
            [
              _c(
                "th",
                {
                  staticClass: "first-col",
                  on: {
                    click: function ($event) {
                      return _vm.handleSortByColumn("hotel_code")
                    },
                  },
                },
                [_c("button", [_vm._v("Hotel")])]
              ),
              _vm._v(" "),
              _vm._l(_vm.months, function (month) {
                return [
                  _c(
                    "th",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.handleSortByColumn(month)
                        },
                      },
                    },
                    [
                      _c(
                        "button",
                        [
                          _vm._v(_vm._s(month) + " \n                        "),
                          _vm.sortColumn == month &&
                          _vm.sortDirection == "asc" &&
                          !_vm.sortLoading
                            ? _c("v-icon", [_vm._v("keyboard_arrow_up")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.sortColumn == month &&
                          _vm.sortDirection == "desc" &&
                          !_vm.sortLoading
                            ? _c("v-icon", [_vm._v("keyboard_arrow_down")])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.sortColumn == month && _vm.sortLoading
                            ? _c("v-icon", { staticClass: "spin" }, [
                                _vm._v("sync"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm._l(_vm.hotelResults, function (hotel) {
            return _vm.hotelResults
              ? [
                  _c(
                    "tr",
                    {
                      class: {
                        "greyed-out":
                          _vm.selectedHotelKey != hotel.hotel_key &&
                          _vm.roomView,
                        selected:
                          _vm.selectedHotelKey == hotel.hotel_key &&
                          _vm.roomView,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleRowClick(hotel.hotel_key)
                        },
                      },
                    },
                    [
                      _c("td", { staticClass: "first-col" }, [
                        _vm._v(
                          " " +
                            _vm._s(hotel.hotel_code) +
                            " - " +
                            _vm._s(hotel.hotel_name)
                        ),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.months, function (month) {
                        return [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.getMonthMissingPercentage(month, hotel)
                              ) + "%"
                            ),
                          ]),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.roomResults, function (room) {
                    return _vm.selectedHotelKey == hotel.hotel_key &&
                      _vm.roomView
                      ? _c(
                          "tr",
                          [
                            _c("td", [_vm._v(_vm._s(room.name))]),
                            _vm._v(" "),
                            _vm._l(_vm.months, function (month) {
                              return [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getMonthMissingPercentage(month, room)
                                    ) + "%"
                                  ),
                                ]),
                              ]
                            }),
                          ],
                          2
                        )
                      : _vm._e()
                  }),
                ]
              : _vm._e()
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }